<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" :append-to-body="true" top="2rem" center>
			<el-form :model="sendDataInfo" v-if="formData" label-width="120px" size="mini">
				<el-row>
					<el-col :span="12" v-for="(formOneValue,formOneKey) in formData.jurconfigform" :key="formOneKey"  v-if="formOneValue.isShow==1">
						<el-form-item :label="formOneValue.showField" :hide-required-asterisk="formOneValue.isRequired == 1 ? true : false">
							<!-- 系统字段 -->
							<div v-if="formOneValue.isReserved == 0">
								<el-input v-if="formOneValue.entityField == 'sbiAddress'"   type="textarea"  placeholder="请输入内容"   v-model="sendDataInfo[formOneValue.entityField]" maxlength="64" show-word-limit>
								</el-input>
								<el-radio-group  v-else-if="formOneValue.entityField == 'sbiState'"  v-model="sendDataInfo[formOneValue.entityField]">
									<el-radio-button :label="0">禁用</el-radio-button>
									<el-radio-button :label="1">启用</el-radio-button>
								</el-radio-group>
								<el-input v-else-if="formOneValue.entityField == 'sfiAcollect'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else-if="formOneValue.entityField == 'sfiApayment'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else-if="formOneValue.entityField == 'sfiCreditamount'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else-if="formOneValue.entityField == 'sfiScollect'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else-if="formOneValue.entityField == 'sfiSpayment'"   type="number"   v-model="sendDataInfo[formOneValue.entityField]">
								</el-input>
								<el-input v-else  v-model.trim="sendDataInfo[formOneValue.entityField]" maxlength="64"></el-input>
								
							</div>
							<!-- 扩展字段 -->
							<div v-if="formOneValue.isReserved == 1">
								
								<!-- 自填 -->
								<el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0"  maxlength="64">
									
								</el-input>
								<!-- 选择数据来源 -->
								<el-input v-model.trim="sendDataInfo[formOneValue.entityField]"  v-else  maxlength="64"  
									@focus="$refs['showSelectData'].openBox(formOneValue.dsmName,formOneValue.entityField,formOneValue.dsmField)">
								</el-input>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dataActionBox.showStatus = false">取 消</el-button>
				<el-button type="primary" @click="sendDataAction()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'supplierFinance',
	// props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
			     "sfiAcollect": 0,
			      "sfiApayment": 0,
			      "sfiCreater": 0,
			      "sfiCreditamount": 0,
			      "sfiCreditperiod": "",
			      "sfiReserves1": "",
			      "sfiReserves2": "",
			      "sfiReserves3": "",
			      "sfiReserves4": "",
			      "sfiReserves5": "",
			      "sfiReserves6": "",
			      "sfiScollect": 0,
			      "sfiSpayment": 0,
			      "smId": 0
			},
			formData:{},
			
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		isShowData(name,value){
			this.sendDataInfo[name] = value
		},
		initActionBox(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			this.dataActionBox.actionType = 0
			this.dataActionBox.showStatus = false
		},
		openBox(cate,formData,mainId,oldData=''){
			this.formData = formData
			this.initActionBox()
			this.sendDataInfo.smId = mainId
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增财务信息'
				this.dataActionBox.openMode = 'ltr'
			}else{
				this.dataActionBox.boxTitle = '编辑财务信息'
				this.dataActionBox.openMode = 'rtl'
				for(let key in oldData){
					this.sendDataInfo[key]  = oldData[key]
				}
				
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		
		// 新增或修改
		async sendDataAction(){
			if(this.sendDataInfo.sbiNumber ==''){
				this.$message({
					message: '请填写账号',
					type: 'error'
				});
				return false
			}
			let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
			this.$emit('returnFinance',sendData,this.dataActionBox.actionType)
			this.dataActionBox.showStatus = false
		},
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>

</style>